import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { BRAND_UI_CONFIG } from "./brandConfig";
import type { CategoryItem } from "./categoryItem";
import { DEFAULT_CATEGORY_CONFIG } from "./discoveryDefaults";

export function mapBrandDataToItems(
  brandData: AutocompleteData[],
): CategoryItem[] {
  return brandData.map((item) => {
    const uiConfig = BRAND_UI_CONFIG[item.value];
    if (!uiConfig)
      console.warn(`[brandData] No UI config for: "${item.value}"`);
    const { image, accentColor } = uiConfig ?? DEFAULT_CATEGORY_CONFIG;
    return {
      id: item.name.toLowerCase().replace(/\s+/g, "-"),
      name: item.name,
      description: item.longDescription ?? "",
      filterValue: item,
      image,
      accentColor,
    };
  });
}
